define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaWfAsset = void 0;
    class WaWfAsset extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "WaWfId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaWfIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FAssetId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FAssetIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "MaintWork", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "MaintWorkError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "MaintMaterial", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "MaintMaterialError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "MaintCondition", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "MaintConditionError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaWaterFacility", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Asset", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, WaWfAsset.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.WaWaterFacility = parent;
            this.WaWfId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.WaWaterFacility = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.WaWfId = (0, EntityUtil_1.toInt)(entity.WaWfId);
            a.FAssetId = (0, EntityUtil_1.toInt)(entity.FAssetId);
            a.MaintWork = b.MaintWork;
            a.MaintMaterial = b.MaintMaterial;
            a.MaintCondition = b.MaintCondition;
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, WaWfAsset.AliasName);
            this.reset();
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "WaWfId", "Water Agreement Water Facility ID");
                this.validateReqNumber(validationState, "FAssetId", "Facility Asset ID");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                WaWfId: this.WaWfId,
                FAssetId: this.FAssetId,
                MaintWork: this.MaintWork,
                MaintMaterial: this.MaintMaterial,
                MaintCondition: this.MaintCondition,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        get TypeDesc() {
            if (this.Asset) {
                return this.Asset.TypeDesc;
            }
            return "";
        }
        get Barcode() {
            if (this.Asset) {
                return this.Asset.Barcode;
            }
            return "";
        }
        get OwnerType() {
            if (this.Asset) {
                return this.Asset.OwnerType;
            }
            return 0;
        }
    }
    exports.WaWfAsset = WaWfAsset;
    Object.defineProperty(WaWfAsset, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "WaWfAsset"
    });
    Object.defineProperty(WaWfAsset, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "WA Facility Asset "
    });
    Object.defineProperty(WaWfAsset, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "WaWfId", "FAssetId", "MaintWork", "MaintMaterial", "MaintCondition"]
    });
    Object.defineProperty(WaWfAsset, "WaWfIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaWfAsset, "FAssetIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaWfAsset, "MaintWorkLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1024
    });
    Object.defineProperty(WaWfAsset, "MaintWorkTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Describe the work that is expected to be performed by the landowner"
    });
    Object.defineProperty(WaWfAsset, "MaintWorkReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaWfAsset, "MaintMaterialLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1024
    });
    Object.defineProperty(WaWfAsset, "MaintMaterialTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "List the materials that should be supplied by the landowner"
    });
    Object.defineProperty(WaWfAsset, "MaintMaterialReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaWfAsset, "MaintConditionLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1024
    });
    Object.defineProperty(WaWfAsset, "MaintConditionTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Describe the condition the equipment is expected to kept in"
    });
    Object.defineProperty(WaWfAsset, "MaintConditionReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWfAsset.prototype, "WaWfId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWfAsset.prototype, "WaWfIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWfAsset.prototype, "FAssetId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWfAsset.prototype, "FAssetIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWfAsset.prototype, "MaintWork", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWfAsset.prototype, "MaintWorkError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWfAsset.prototype, "MaintMaterial", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWfAsset.prototype, "MaintMaterialError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWfAsset.prototype, "MaintCondition", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWfAsset.prototype, "MaintConditionError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWfAsset.prototype, "WaWaterFacility", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], WaWfAsset.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaWfAsset.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaWfAsset.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWfAsset.prototype, "Asset", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], WaWfAsset.prototype, "TypeDesc", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], WaWfAsset.prototype, "Barcode", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], WaWfAsset.prototype, "OwnerType", null);
});
